const codebook = (state = {}, action) => {
  switch (action.type) {
    case "ADD_CODEBOOK":
      return Object.assign({}, state, {
        [action.codebookName]: action.collection
      });
    default:
      return state;
  }
};

export default codebook;
